import {EventEmitter, Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {KeyLog} from '../types/models';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {filter, map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';
import {of} from 'rxjs/observable/of';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class KeyLogService {
    isKeyLogModalShow = false;
    returnKeyModal = false;
    signOutKeyModal = false;
    showHistoryModal = false;
    isViewModalShow = false;
    showServiceUnavailable = false;

    keyLoginKeyLogModal: KeyLog;

    data = {
        allKeyLogs: {
            get: '/v1/key_log.json?expand=building,suite,resident,incidentReportType,createdBy',
            data: [],
            total: null
        },
    };
    tabId = 'keyLog';
    spinnerShow = true;
    detailedViewHistorySpinnerShow = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    serviceName: string = 'key_log';
    selectedItemData: any;
    showDetailedView = false;
    activities = [];
    corporationSettings = null;
    settingsLoaded: EventEmitter<any> = new EventEmitter();

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData(scrollToTop?) {
        this.getDataByQueryParams(scrollToTop).subscribe();
    }

    getDataByQueryParams(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.data[this.tabId].total = null;

        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        return this.api.getJson('domainKeyLog', `${url}${queryParams}`)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity((item) => {
                    if (item.building && item.building.bdId) item.building.id = item.building.bdId;
                    return KeyLog.fromExistingData(this.account.addPermissionsToEntity(item, this.serviceName));
                }),
                tap(({finished}) => this.spinnerShow = !finished),
                tap(body => {
                    this.data[tabId].data = body.entities;
                    this.data[tabId].total = body.total;
                }),
                tap(() => this.emptyRowService.fillEmptyRow()),
                tap(
                    () => {
                        if ($('.table')[0] && scrollToTop)
                            $('.table')[0].scrollIntoView();
                    },
                    (error) => {
                        this.spinnerShow = false;
                        this.showServiceUnavailable = true;
                        this.api.errorHandler(error, 'Failed get Key Log');
                    }
                ),
                filter(({finished}) => finished),
                tap(
                    () => {
                        if (this.selectedItemData) {
                            this.selectedItemData = this.data[tabId].data.find(si => si.id == this.selectedItemData.id);
                            if (this.selectedItemData) {
                                this.selectedItemData.checked = true;
                                this.getActivity();
                            } else {
                                this.showDetailedView = false;
                            }
                        }
                    }
                )
            );
    }

    getBuildings(): Observable<any> {
        if (this.buildings.length) return of(this.buildings);
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc&expand=timeZone`;
        return this.api.getJson('domainBD', url)
            .pipe(
                tap(
                    (res) => {
                        this.buildings = res.entities;
                        this.getFilteredBuildings();
                    },
                    (error) => this.api.errorHandler(error, 'Failed get buildings')
                ),
                map(res => res.entities)
            );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    signOutKey(keyLog: KeyLog) {
        this.signOutKeyModal = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    returnKey(keyLog: KeyLog) {
        this.returnKeyModal = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    deleteKeyLog(keyLog: KeyLog): void {
        if (!keyLog.id) return;
        swal(ConstantsService.getSwalConfig('Delete Key Log'),
            () => {
                const url = `/v1/key_log/${keyLog.id}.json`;
                this.api.remove('domainKeyLog', url).subscribe(
                    () => {
                        toastr.success('Key Log has been deleted.');
                        this.toggleDetailedView(null);
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Key Log failed')
                );
            }
        );
    }

    editKeyLog(keyLog) {
        this.keyLoginKeyLogModal = JSON.parse(JSON.stringify(keyLog));
        this.isKeyLogModalShow = true;
    }

    viewKeyLog(keyLog) {
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
        this.isViewModalShow = true;
    }

    getHistory(keyLog: KeyLog): void {
        this.showHistoryModal = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    canEdit(buildingId?: number) {

        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {

        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    toggleDetailedView(data): void {
        this.activities = [];
        if (data && (!this.selectedItemData || this.selectedItemData.id != data.id)) {
            if (this.selectedItemData)
                this.selectedItemData.checked = false;
            this.selectedItemData = null;
            this.showDetailedView = true;
            data.checked = true;
            setTimeout(() => {
                this.selectedItemData = data;
                this.getActivity();
                for (const field in this.selectedItemData.formFields)
                    this.selectedItemData.formFields[field].editMode = false;
            });
        } else if (this.selectedItemData && data && this.selectedItemData.id == data.id) {
            this.selectedItemData = null;
            this.showDetailedView = false;
            data.checked = false;
        } else {
            this.showDetailedView = false;
            this.selectedItemData.checked = false;
            this.selectedItemData = null;
        }
    }

    getActivity() {
        if (this.selectedItemData) {
            this.detailedViewHistorySpinnerShow = true;
            const url = `/v1/activity.json?per-page=10000&order-by=createdAt|desc&expand=user,createdBy&key_log_id=${this.selectedItemData.id}`;
            this.api.get('domainKeyLog', url).subscribe(
                (res) => this.activities = JSON.parse(res._body).entities,
                (error) => this.api.errorHandler(error, 'Failed to get History'),
                () => this.detailedViewHistorySpinnerShow = false
            );
        }
    }

    getSettingsForCorporation(corporationNumberId) {
        const url = `/v1/service_settings/${corporationNumberId}.json?expand=staffNotificationSettings`;
        this.api.get('domainKeyLog', url).subscribe(
            res => {
                this.corporationSettings = null;
                const body = JSON.parse(res._body);
                this.corporationSettings = body ? body : null;
                this.settingsLoaded.emit();
            }, error => {
                if (error.statusText == 'Not Found') {
                    this.corporationSettings = null;
                    this.settingsLoaded.emit();
                } else
                    this.api.errorHandler(error, 'Failed to get key log settings for the chosen corporation');
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/key-log.service.ts